/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpIcon24Solid = forwardRef('ArrowAUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M5.186 10.998a1.5 1.5 0 1 1-2.122-2.121l6.284-6.284a3.75 3.75 0 0 1 5.304 0l6.284 6.284a1.5 1.5 0 0 1-2.122 2.121L13.5 5.684V21a1.5 1.5 0 1 1-3 0V5.684l-5.314 5.314Z" })));
});
